module.exports = __webpack_public_path__ + "img/miro.6e730e10.svg";